__webpack_require__.p = "/beamer-snippet-poc/referrals-hub/";